const baseUrl = 'http://ce.ceidata.cn/qtccei/';
/*const baseUrl = 'http://vue.qtc.com:9002/';*/
/*const baseUrl = 'http://47.94.217.142/';*/
/*const baseUrl = 'http://www.qitongcha.com/';*/
export default baseUrl;


// WEBPACK FOOTER //
// ./src/api/base.js